import type { ReactNode } from "react";
import { forwardRef } from "react";

import { Icons } from "widgets";

import type { TileProps } from "../../../../modules/core/components/Tile.js";
import { Tile } from "../../../../modules/core/components/Tile.js";

interface GenomeViewTileProps extends Pick<TileProps, "title" | "footNote" | "to" | "tooltip"> {
  children?: ReactNode; // temporary as there is a known bug in the @types definitions with forwardRef
}

const GenomeViewTile = forwardRef<HTMLDivElement, GenomeViewTileProps>((props, ref) => {
  return (
    <Tile
      {...props}
      type={"Genome View"}
      icon={<img src={Icons.Tiles.GenomeViewer} width={24} height={30} />}
      ref={ref}
    />
  );
});

export { GenomeViewTile };
